<template>
  <div class="m-4 bg-white" style="border-radius: 12px">
    <b-row v-if="maintenanceDetailData" class="p-4">
      <b-col cols="12" class="text-right" v-if="stateAction === 'VIEW_DETAIL'">
      </b-col>
      <b-col cols="12">
        <b-row>
          <!-- NEW UI -->
          <b-col :md="action == 'VIEW_DETAIL' ? 12 : 6" class="mb-4">
            <div class="d-flex align-items-center">
              <div class="w-50 p-5 text-center">
                <img
                  :src="
                    maintenanceDetailData.vehicle?.vehicleType?.icon?.url ??
                    require('@src/assets/images/Km3FO09.png')
                  "
                  alt="images"
                  style="width: 100%"
                />
              </div>
              <div class="w-50">
                <div class="d-flex">
                  <!-- icon -->
                  <div class="mr-2 mb-2">
                    <IconFleet />
                  </div>
                  <div class="d-flex flex-column align-items-start">
                    <strong class="text-primary"
                      >{{ maintenanceDetailData.vehicle.name }} 🇮🇩</strong
                    >
                    <span>{{
                      maintenanceDetailData.vehicle.company.company
                    }}</span>
                  </div>
                </div>
                <div class="d-flex">
                  <table class="table table-striped" style="font-size: 14px">
                    <tbody>
                      <tr>
                        <td>Fleet Type</td>
                        <td>{{
                          maintenanceDetailData.vehicle?.vehicleType?.name
                        }}</td>
                      </tr>
                      <tr>
                        <td>Call Sign</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>Year & Building</td>
                        <td
                          >{{
                            maintenanceDetailData?.vehicle.yearBuildCountry
                          }}
                          / {{ maintenanceDetailData?.vehicle.flag }}</td
                        >
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column" v-if="action !== 'VIEW_DETAIL'">
              <CustomNav
                :items="navItems"
                class="mb-3"
                @item-click="(val) => (viewMenu1 = val)"
              />

              <!-- CONTENT TABS -->
              <b-row>
                <b-col md="12" v-if="viewMenu1 === 'rh'">
                  <MaintenanceRhList
                    :maintenanceDetailData="maintenanceDetailData"
                  />
                </b-col>
                <b-col md="12" v-if="viewMenu1 === 'mi'">
                  <MaintenanceInfoList
                    :maintenanceDetailData="maintenanceDetailData"
                    @handleOpenFilePreview="handleOpenFilePreview"
                  />
                </b-col>
                <b-col md="12" v-if="viewMenu1 === 'ei'">
                  <MaintenanceInitInfo
                    :maintenanceDetailData="maintenanceDetailData"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>

          <!-- TABS - 2 -->
          <b-col :md="action == 'VIEW_DETAIL' ? 12 : 6" class="mb-4">
            <CustomNav
              :items="navItems2"
              class="mb-3"
              @item-click="(val) => (viewMenu2 = val)"
            />
            <!-- CONTENT TABS -->
            <b-row>
              <b-col md="12" v-if="viewMenu2 === 'mp'">
                <template
                  v-if="
                    ['ON_MAINTENANCE', 'ON_POSTPONE', 'ON_CONVERT'].includes(
                      stateAction
                    ) && !isEdit
                  "
                >
                  <template v-if="stateAction === 'ON_MAINTENANCE'">
                    <OnMaintenanceForm
                      v-model="formMaintenance"
                      @submitForm="saveMaintenance"
                      :maintenanceDetailData="maintenanceDetailData"
                      @uploadFile="uploadFile"
                    />
                  </template>
                  <b-row v-else-if="stateAction === 'ON_POSTPONE'">
                    <b-col
                      cols="6"
                      v-if="maintenanceDetailData.trigger === 'COUNTER'"
                    >
                      <b-form-group label="Extra Hours *">
                        <input
                          type="number"
                          v-model="formPostpone.extraHours"
                          class="form-control"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="6"
                      v-if="maintenanceDetailData.trigger === 'CALENDAR'"
                    >
                      <b-form-group label="Extra Date *">
                        <input
                          type="date"
                          v-model="formPostpone.extraDate"
                          class="form-control"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group label="Reason *">
                        <b-form-textarea
                          rows="3"
                          placeholder="Type Reason"
                          v-model="formPostpone.reason"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col md="6" class="text-center">
                      <button
                        type="button"
                        @click="onAction('VIEW_DETAIL')"
                        class="btn btn-outline-primary w-100"
                        >Cancel</button
                      >
                    </b-col>
                    <b-col md="6" class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary w-100"
                        @click="savePostpone()"
                        >Submit</button
                      >
                    </b-col>
                  </b-row>
                </template>
                <template
                  v-if="
                    ['REVIEW', 'APPROVE'].includes(maintenanceDetailData.status)
                  "
                >
                  <b-row v-if="isEdit">
                    <b-col md="6" class="text-center">
                      <button
                        type="button"
                        @click="onAction('VIEW_DETAIL')"
                        class="btn btn-outline-primary w-100"
                        >Cancel</button
                      >
                    </b-col>
                    <b-col md="6" class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary w-100"
                        @click="editDoMaintenance()"
                        >Save Update</button
                      >
                    </b-col>
                  </b-row>
                </template>
                <template
                  v-if="
                    action == 'VIEW_DETAIL' ||
                    action == 'ON_REVIEW' ||
                    action == 'ON_APPROVE'
                  "
                >
                  <MaintenanceInfoDetail
                    :maintenanceDetailData="maintenanceDetailData"
                    @handleOpenFilePreview="handleOpenFilePreview"
                  />
                </template>
              </b-col>

              <b-col md="12" v-if="viewMenu2 === 'lh'">
                <div
                  class="overflow-auto d-flex w-100"
                  style="max-height: 400px"
                >
                  <b-row>
                    <b-col lg="12">
                      <div class="p-3 px-3">
                        <LogsTemplate :logs="maintenanceDetailData.logs" />
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>

              <b-col md="12" v-if="viewMenu2 === 'com'">
                <MaintenanceCommentForm
                  :maintenanceId="maintenanceId"
                  :maintenanceDetailData="maintenanceDetailData"
                  @refetch="() => fetchMaintenanceDetail(maintenanceId)"
                />
              </b-col>

              <b-col md="12">
                <b-row v-if="action == 'ON_REVIEW' || action == 'ON_APPROVE'">
                  <b-col md="6" class="text-center">
                    <button
                      type="button"
                      @click="$emit('close')"
                      class="btn btn-outline-primary w-100"
                      >Cancel</button
                    >
                  </b-col>
                  <b-col md="6" class="text-center">
                    <button
                      v-if="action == 'ON_REVIEW'"
                      type="button"
                      class="btn btn-primary w-100"
                      @click="$emit('onReview', maintenanceId)"
                      >Review</button
                    >
                    <button
                      v-if="action == 'ON_APPROVE'"
                      type="button"
                      class="btn btn-primary w-100"
                      @click="$emit('onApprove', maintenanceId)"
                      >Approve</button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <!-- TABS -->
          <b-col md="6" class="mb-4"> </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  filesActions,
  fleetsActions,
  maintenanceActions,
} from '@src/Utils/helper'
import { numberFormat } from '@src/plugins/helpers'
import moment from 'moment'
import IconFleet from './Components/Icons/IconFleet'
import CustomNav from '@/src/components/global/CustomNav.vue'
import FormServiceAndRepair from '@/src/views/Sr/components/FormServiceAndRepair.vue'
import MaintenanceInfoList from './Components/Tabs/MaintenanceInfoList.vue'
import MaintenanceInitInfo from './Components/Tabs/MaintenanceInitInfo.vue'
import MaintenanceRhList from './Components/Tabs/MaintenanceRhList.vue'
import OnMaintenanceForm from './Components/Tabs/OnMaintenanceForm.vue'
import LogsTemplate from '@/src/components/global/LogsTemplate.vue'
import MaintenanceInfoDetail from './Components/Tabs/MaintenanceInfoDetail.vue'
import MaintenanceCommentForm from './Components/Tabs/MaintenanceCommentForm.vue'

export default {
  name: 'ViewMaintenanceDetail',
  components: {
    IconFleet,
    CustomNav,
    FormServiceAndRepair,
    MaintenanceInfoList,
    MaintenanceInitInfo,
    MaintenanceRhList,
    OnMaintenanceForm,
    LogsTemplate,
    MaintenanceInfoDetail,
    MaintenanceCommentForm,
  },
  props: {
    maintenanceId: {
      type: Number,
      require: true,
    },
    action: {
      type: String,
      default: 'VIEW_DETAIL',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    jobClassList: {
      type: Array,
      default: () => [],
    },
    onApprove: {
      type: Function,
      default: () => {},
    },
    onReview: {
      type: Function,
      default: () => {},
    },
    jobTypeList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    maintenanceId: {
      immediate: true,
      async handler(value) {
        if (value) {
          await this.fetchMaintenanceDetail(value)
          await this.getComponentStruct()
        }
      },
    },
    stateAction: {
      immediate: true,
      async handler(value) {
        let title = ''

        switch (value) {
          case 'VIEW_DETAIL':
            title = ['FINISH'].includes(this.maintenanceDetailData?.status)
              ? 'Finished Maintenance Detail'
              : ' Maintenance Detail'
            break
          case 'ON_MAINTENANCE':
            title = 'Create Maintenance'
            break
          case 'ON_POSTPONE':
            title = 'Postponed Maintenance'
            break
          case 'ON_CONVERT':
            title = 'Convert Service & Repair'
            break
          default:
            title = 'Detail Maintenance'
            break
        }

        setTimeout(() => {
          document.getElementById(
            'view-detail-maintenance___title__'
          ).innerText = title
        }, 300)
      },
    },
  },
  data() {
    return {
      stateAction: 'VIEW_DETAIL',
      viewMenu1: 'mi',
      viewMenu2: 'mp',

      checkedFleets: [],
      maintenanceDetailData: {
        logs: [],
      },
      treeInitMaintenance: [],
      formMaintenance: {
        fileName: '',
        maintenanceDate: '',
        maintenanceRunningHours: '',
        cost: '',
        notes: '',
        possibleMaintenanceDate: '',
      },
      formPostpone: {
        reason: '',
        extraHours: '',
        extraDate: '',
      },
      formEdit: {
        fileName: '',
        maintenanceDate: '',
        maintenanceRunningHours: 0,
        cost: 0,
        notes: '',
      },
      lsProfile: JSON.parse(localStorage.getItem('profile')),
      navItems: [
        { label: 'Last Maintenance Info', value: 'mi' },
        { label: 'Maintenance Initiation Info', value: 'ei' },
        { label: 'Running Hours', value: 'rh' },
      ],
    }
  },
  computed: {
    maintenancePermission() {
      return this.lsProfile.menu
        .find((menu) => menu.menu === 'Apps')
        ?.child.find((child) => child.menu === 'Technical')
        ?.child.find((child) => child.menu === 'Maintenance')
    },
    canAdd() {
      return this.maintenancePermission
        ? this.maintenancePermission?.add
        : false
    },
    canEdit() {
      return this.maintenancePermission
        ? this.maintenancePermission?.update
        : false
    },
    canApprove() {
      return this.maintenancePermission
        ? this.maintenancePermission?.approval
        : false
    },
    canReview() {
      return this.maintenancePermission
        ? this.maintenancePermission?.review
        : false
    },
    canDelete() {
      return this.maintenancePermission
        ? this.maintenancePermission?.delete
        : false
    },
    canExport() {
      return this.maintenancePermission
        ? this.maintenancePermission?.export
        : false
    },
    navItems2() {
      let menus = [
        { label: 'Log History', value: 'lh' },
        { label: 'Comment', value: 'com' },
      ]
      if (
        ['ON_MAINTENANCE', 'ON_POSTPONE', 'ON_CONVERT'].includes(
          this.stateAction
        ) ||
        ['REVIEW', 'APPROVE', 'FINISH'].includes(
          this.maintenanceDetailData.status
        )
      ) {
        return [{ label: 'Maintenance Progress', value: 'mp' }, ...menus]
      } else {
        return menus
      }
    },
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...filesActions,
    handleOpenFilePreview: function (url) {
      window.open(url, '_blank')
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    async fetchMaintenanceDetail(maintenanceId) {
      const res = await this.getMaintenanceDetail(maintenanceId)
      if (res.status === 'success') {
        if (res.data) {
          this.maintenanceDetailData = { ...res.data, maintenanceId }
          this.maintenanceDetailData.logs = res.data.logs?.map((el) => ({
            name: el.createdBy,
            date: moment(el.createdAt).format('DD MMM YYYY HH:mm'),
            description: `Changed status to ${el?.status}`,
          }))
          this.checkedFleets.push({
            ...this.maintenanceDetailData.vehicle,
            componentSetup: [],
          })

          let dueMaintenanceDate = res.data?.possibleMaintenanceDate
          if (res.data?.postpone?.length) dueMaintenanceDate = res.data.postpone[0].extraDate

          this.componentIdSelected = this.maintenanceDetailData.component.id
          this.formMaintenance.possibleMaintenanceDate = dueMaintenanceDate
          this.formMaintenance.maintenanceDate = dueMaintenanceDate

          this.maintenanceDetailData.vehicle.powers.sort((a, b) => {
            return a.powerType.id - b.powerType.id
          })

          this.formEdit = {
            fileName: '',
            maintenanceDate: this.maintenanceDetailData.maintenanceDate,
            maintenanceRunningHours:
              this.maintenanceDetailData.maintenanceRunningHours,
            cost: this.maintenanceDetailData.cost,
            notes: this.maintenanceDetailData.notes,
          }
          await this.componentSetupCheck()
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
    async componentSetupCheck() {
      const paramsQ = {
        vehicleIds: [],
      }

      if (this.checkedFleets && this.checkedFleets.length > 0) {
        this.checkedFleets.forEach((el) => {
          paramsQ.vehicleIds.push(el.id)
        })
        paramsQ.vehicleIds = paramsQ.vehicleIds.toString()
      }

      const dataNeed = {
        id: this.componentIdSelected,
        params: paramsQ,
      }

      const res = await this.checkHasComponentSetup(dataNeed)

      if (res.status === 'success') {
        if (res.data.data && res.data.data.length > 0) {
          if (this.checkedFleets && this.checkedFleets.length > 0) {
            res.data.data.forEach((el) => {
              this.checkedFleets.forEach((fleet) => {
                if (fleet.id === el.vehicle.id) {
                  fleet.componentSetup = []
                  el.componentSetup.forEach((componentSetup) => {
                    fleet.componentSetup.push(componentSetup)
                  })
                }
              })
            })
          }
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
    async getComponentStruct() {
      this.treeInitMaintenance = []
      const paramsQ = {
        vehicleTypeId: 1,
      }
      const res = await this.getComponent(paramsQ)

      if (res.status === 'success') {
        if (
          res.data.maintenanceComponents &&
          res.data.maintenanceComponents.length > 0
        ) {
          const dataTemp = res.data.maintenanceComponents
          dataTemp.forEach((s) =>
            this.treeInitMaintenance.push(this.putStructureObject(s))
          )
        }
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
    async saveMaintenance() {
      let payload = {
        id: this.maintenanceId,
        data: this.formMaintenance,
      }
      const res = await this.saveDoMaintenance(payload)

      if (res.status === 'success') {
        this.$swal(`Maintenance Berhasil`, '', 'success')
        await this.fetchMaintenanceDetail(this.maintenanceId)
        this.onAction('VIEW_DETAIL')
        this.$emit('save')
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
    async savePostpone() {
      if (!this.formPostpone.reason) {
        return alert('Lengkapi form postpone terlebih dahulu')
      }

      let payload = {
        id: this.maintenanceId,
        data: {
          ...this.formPostpone,
          extraDate: moment(this.formPostpone.extraDate).format('DD-MM-YYYY'),
        },
      }
      const res = await this.savePostponeMaintenance(payload)

      if (res.status === 'success') {
        this.$swal(`Postpone Berhasil`, '', 'success')
        await this.fetchMaintenanceDetail(this.maintenanceId)
        this.onAction('VIEW_DETAIL')
        this.$emit('save')
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
    async editDoMaintenance() {
      let payload = {
        id: this.maintenanceId,
        data: {
          ...this.formEdit,
        },
      }

      const res = await this.updateDoMaintenance(payload)

      if (res.status === 'success') {
        this.$swal(`Update Maintenance Berhasil`, '', 'success')
        await this.fetchMaintenanceDetail(this.maintenanceId)
        this.onAction('VIEW_DETAIL')
        this.$emit('save')
      } else {
        this.$swal(`Oops!`, res.data.message, 'error')
      }
    },
    async uploadFile(event) {
      console.log('masuk sini ')

      const files = [...event.target.files]
      let file = files[0]

      let formData = new FormData()
      formData.append('file', file)

      let res = await this.upload(formData)
      if (res.status === 'success') {
        if (this.isEdit) {
          this.formEdit.fileName = res.data.fileName
        } else {
          this.formMaintenance.fileName = res.data.fileName
        }
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }
    },

    putStructureObject(object) {
      let children = []

      if (object.child.length > 0) {
        object.child.forEach((child) =>
          children.push(this.putStructureObject(child))
        )
      }

      let selected =
        this.maintenanceDetailData && this.maintenanceDetailData.component
          ? this.maintenanceDetailData.component.id === object.component.id
          : false
      let disabled = this.maintenanceDetailData

      return {
        id: object.component.id,
        text: object.component.componentName,
        disabled,
        opened: true,
        selected,
        children,
      }
    },
    onAction(action) {
      this.resetFormMaintenance()
      this.resetFormPostpone()

      this.stateAction = action
    },
    resetFormMaintenance() {
      this.formMaintenance = {
        fileName: '',
        maintenanceDate: '',
        maintenanceRunningHours:
          this.maintenanceDetailData?.power?.actualRunningHours ?? 0,
        cost: '',
        notes: '',
      }
    },
    resetFormPostpone() {
      this.formPostpone = {
        reason: '',
        extraHours: '',
        extraDate: '',
      }
    },
    numberFormat(number) {
      return numberFormat(number)
    },
    async setServiceAndRepair(e) {
      e.preventDefault()
    },
  },
  mounted() {
    this.onAction(this.action)
  },
}
</script>

<style>
.ul-lists-styled ul,
.ul-lists-styled {
  list-style: circle;
}
.log-history {
  /* background: blue; */
  position: relative;
}
.circle-dot {
  border: 1px solid #1f48aa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18px;
  width: 18px;
  position: absolute;
  top: -5px;
}
.circle-dot .dot {
  background: #1f48aa;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.border-l-blue {
  border-left: 2px solid #e5e7eb;
}

.left-8 {
  left: -8px;
}
.left-10 {
  left: -10px;
}
</style>
